<template>
	<div v-if="isSearched && canvases.total == 0" class=" alert alert-dark" role="alert">
		{{ __('translations.message.no_result_found') }}
    </div>
	<div v-else-if="isSearched">
		<div class="row justify-content-center">
			<div class="col-12">
	            <h4 v-if="canvases.total > 0" class="mb-0">
	                <span v-if="canvases.total === 1">{{canvases.total}} document is found.</span>
	                <span v-else-if="canvases.total > 1">{{canvases.total}} documents are found.</span>
                </h4>
	        </div>
	    </div>
    	<div v-if="canvases.total > 0" style="margin-left:-1rem; margin-right:-1rem;">
        	<canvases v-if="!isCanvasLoading" :display-header="false"></canvases>
        	
        	<div v-if="isCanvasLoading" class="row mt-5 mx-0">
		    	<div class="col text-center">
			    	<div class="spinner-border" role="status" style="color: #ccc">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
		    </div>
		    
       		<div v-if="canvases.last_page > 1" class="row my-5">
   				<div class="col text-center">
   					<button :disabled="canvases.current_page <= 1" class="btn btn-primary mr-2" @click="loadCanvases(1)"><i class="fas fa-angle-double-left" style="vertical-align: middle;"></i></button>
   					<button :disabled="canvases.current_page <= 1" class="btn btn-primary mr-2" @click="loadCanvases(parseInt(canvases.current_page) - 1)"><i class="fas fa-angle-left" style="vertical-align: middle;"></i></button>
   					<div class="d-inline-block" style="color: #3f5864">
   						Page <input type="text" v-model="canvases.current_page" @keyup.enter="loadCanvases(canvases.current_page)" class="form-control d-inline-block mx-2" style="width: 50px" /> sur {{canvases.last_page}}
  						</div>
   					<button :disabled="canvases.current_page >= canvases.last_page" class="btn btn-primary ml-2" @click="loadCanvases(parseInt(canvases.current_page) + 1)"><i class="fas fa-angle-right" style="vertical-align: middle;"></i></button>
   					<button :disabled="canvases.current_page >= canvases.last_page" class="btn btn-primary ml-2" @click="loadCanvases(canvases.last_page)"><i class="fas fa-angle-double-right" style="vertical-align: middle;"></i></button>
  					</div>
			</div>
        </div>
	</div>
	<div v-else-if="isSearching" class="row mt-5 mx-0">
    	<div class="col text-center">
	    	<div class="spinner-border" role="status" style="color: #ccc">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
var moment = require('moment');

export default {
    data() {
        return {
            isCanvasLoading: false
        }
    },
    computed: {
		...mapGetters([
			'canvases', 'isSearching', 'isSearched'
		]),
    },
    methods: {
    	loadCanvases(pageNum) {
    		this.canvases.current_page = pageNum;
    		this.isCanvasLoading = true;
    		
    		var params = this.$store.state.searchParams;
    		params.page = pageNum;
    		
    		this.$store.commit('SET_SEARCH_PARAMS', params);
    		this.$store.dispatch('GLOBAL_SEARCH').then((response) => {
    			this.isCanvasLoading = false;
    		});
    	},
	}
}
</script>